import type { ProductShort } from "~/types/product";

/**
 * Identity of a product inside a rendered list (v-for key, per-card lookups).
 *
 * Usually that's the SKU, but one SKU can come back from Klevu as several
 * records: the box finder gets a separate record for each height a
 * multi-height box closes at, each with its own dimensions (PKNEW-1510). The
 * Klevu record id tells those apart; products that didn't come from Klevu have
 * no record id and fall back to the SKU.
 */
export function productListKey(
  product: Pick<ProductShort, "_klevu_id" | "sku">,
): string {
  return product._klevu_id || product.sku;
}
